<template>
    <div class="section pt-2 pb-5">

        <div class="section mt-1">
            <div class="tab-container-1">
                <nav class="pill-tabs" aria-label="Member Categories">
                    <button class="pill-tab" :class="{ active: wing === 1 }" @click="setWing(1)" type="button">{{ $t('wisdom') }}</button>
                    <button class="pill-tab" :class="{ active: wing === 2 }" @click="setWing(2)" type="button">{{ $t('youth') }}</button>
                    <button class="pill-tab" :class="{ active: wing === 3 }" @click="setWing(3)" type="button">{{ $t('students') }}</button>
                    <button class="pill-tab" :class="{ active: wing === 4 }" @click="setWing(4)" type="button">{{ $t('women') }}</button>
                    <button class="pill-tab" :class="{ active: wing === 5 }" @click="setWing(5)" type="button">{{ $t('balavedi') }}</button>
                    <button class="pill-tab" :class="{ active: wing === 6 }" @click="setWing(6)" type="button">{{ $t('girls') }}</button>
                </nav>
            </div>
        </div>

        <!-- Filter by CURRENT tracked location — cascading district/zone/unit narrows within
             whatever the viewer's own admin level already sees; the two quick-filters isolate
             members currently tracked outside Kerala / outside India entirely. -->
        <div class="card p-3 mb-3" style="border-radius:12px;" v-if="currentUser">
            <label class="field-label">നിലവിലെ സ്ഥലം അനുസരിച്ച് ഫിൽട്ടർ ചെയ്യുക</label>
            <div class="d-flex flex-column gap-2 mb-2">
                <select v-if="showDistrictFilter" v-model="filterDistrictId" class="form-control form-control-sm" @change="onFilterDistrictChange">
                    <option value="">എല്ലാ ജില്ലയും</option>
                    <option v-for="d in filterDistrictList" :key="d.id" :value="d.id">{{ d.name }}</option>
                </select>
                <select v-if="showZoneFilter" v-model="filterZoneId" class="form-control form-control-sm" @change="onFilterZoneChange">
                    <option value="">എല്ലാ മണ്ഡലവും</option>
                    <option v-for="z in filterZoneList" :key="z.id" :value="z.id">{{ z.name }}</option>
                </select>
                <select v-if="showUnitFilter" v-model="filterUnitId" class="form-control form-control-sm" @change="onFilterUnitChange">
                    <option value="">എല്ലാ യൂണിറ്റും</option>
                    <option v-for="u in filterUnitList" :key="u.id" :value="u.id">{{ u.name }}</option>
                </select>
            </div>
            <div class="tracking-toggle-row">
                <button type="button" class="tracking-toggle-btn" :class="{ active: filterMode === 'outside_kerala' }" @click="toggleOutsideKerala">കേരളത്തിന് പുറത്ത്</button>
                <button type="button" class="tracking-toggle-btn danger" :class="{ active: filterMode === 'outside_india' }" @click="toggleOutsideIndia">ഇന്ത്യക്ക് പുറത്ത്</button>
            </div>
            <select v-if="filterMode === 'outside_kerala'" v-model="filterState" class="form-control form-control-sm mt-2" @change="onFilterStateChange">
                <option value="">എല്ലാ സംസ്ഥാനവും</option>
                <option v-for="s in state_list" :key="s.id" :value="s.item_value">{{ s.name }}</option>
            </select>
            <select v-if="filterMode === 'outside_india'" v-model="filterCountry" class="form-control form-control-sm mt-2" @change="onFilterCountryChange">
                <option value="">എല്ലാ രാജ്യവും</option>
                <option v-for="c in country_list" :key="c.id" :value="c.item_value">{{ c.name }}</option>
            </select>
        </div>

        <div class="card p-3 mb-3" style="border-radius:12px;">
            <label class="field-label">Search member (name / mobile)</label>
            <input v-model="search" type="text" class="form-control form-control-sm mb-1"
                placeholder="Search to filter, or leave blank to browse all..."
                @input="onSearch" autocomplete="off" />
        </div>

        <div class="section text-center" v-if="loadingList">
            <div class="spinner-border spinner-border-sm text-secondary"></div>
        </div>

        <div v-if="!loadingList && !results.length" class="text-center text-muted py-3 mal-text" style="font-size:12px;">
            ഫലങ്ങളൊന്നും ലഭ്യമല്ല
        </div>

        <ul class="listview image-listview inset text mt-0 mb-2 tracking-listview" v-if="!loadingList && results.length">
            <li v-for="(m, index) in results" :key="m.id" :style="rowStyle(m)">
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{ index + 1 }}</span>
                    <div class="avatar-section">
                        <a href="#">
                            <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        </a>
                    </div>
                    <div class="in">
                        <div class="min-width-50">
                            <b>{{ m.name }}</b>
                            <footer>{{ m.mobile }}</footer>
                            <footer class="mal-text" style="color:#a15c00;font-size:11px;">
                                📍 നിലവിൽ: {{ currentLocationLabel(m) }}
                                <span v-if="isTracked(m) && m.trackedAt"> · {{ formatDate(m.trackedAt) }} മുതൽ</span>
                            </footer>
                            <footer v-if="m.is_tracked_here" class="mal-text" style="color:#1a418c;font-size:11px;">
                                🏠 സ്വദേശം: {{ homeLabel(m) }}
                            </footer>
                        </div>
                        <div class="card-button dropdown">
                            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal" :data-bs-target="'#trackingActionSheet' + m.id">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                </a>

                <!-- Per-row action sheet — "Change Location" for members within this admin's own
                     district/zone/unit, "View Details" (same modal, read-only) for everyone else. -->
                <div class="modal fade action-sheet" :id="'trackingActionSheet' + m.id" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">നടപടി</h5>
                            </div>
                            <div class="modal-body">
                                <ul class="action-button-list">
                                    <li>
                                        <a href="javascript:void(0)" @click="openLocationModal(m)" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon :name="m.canEditLocation ? 'location-outline' : 'eye-outline'"></ion-icon>
                                                {{ m.canEditLocation ? 'Change Location' : 'View Details' }}
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="m.mobile">
                                        <a :href="'tel:' + m.mobile" class="btn btn-list">
                                            <span>
                                                <ion-icon name="call-outline"></ion-icon> Call
                                            </span>
                                        </a>
                                    </li>
                                    <li v-if="m.mobile">
                                        <a :href="'https://wa.me/91' + m.mobile" target="_blank" class="btn btn-list">
                                            <span>
                                                <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <div class="section mt-2" v-if="!loadingList && pagination.total > 0">
            <vue-awesome-paginate :total-items="pagination.total" :items-per-page="20" :max-pages-shown="3"
                v-model="pagination.current_page" :on-click="loadList" :show-ending-buttons="true" :show-breakpoint-buttons="false" />
        </div>

        <!-- Current-location modal — three modes:
             - Kerala: District → Zone → Unit cascade cloned from MembersList.vue's #changeUnitModal
               picker (get-district-by-id/get-zone-by-id/get-unit-by-id), instant save (no
               reason/approval workflow, just tracking). Some zones have no Units at all (e.g.
               individual countries under the "FOREIGN" district) — falls back to zone
               granularity in that case.
             - Outside Kerala: a flat Indian-state pick (existing STATES_INDIA combobox).
             - Outside India: a flat country pick (existing COUNTRY combobox).
             These two are plain text, unrelated to the org hierarchy — "that's enough" per spec. -->
        <div class="modal fade action-sheet" id="locationModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ selected ? selected.name : '' }} — സ്ഥലം മാറ്റുക</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content" v-if="selected && !selected.canEditLocation">
                            <!-- Not this admin's own district/zone/unit — view only, matching
                                 canEditLocation computed server-side in listMembersTracking(). -->
                            <div class="form-group basic">
                                <label class="label">നിലവിലെ സ്ഥലം</label>
                                <div class="loc-view-value">{{ currentLocationLabel(selected) }}</div>
                            </div>
                            <div class="form-group basic" v-if="selected.trackedMobile">
                                <label class="label">മൊബൈൽ നമ്പർ</label>
                                <div class="loc-view-value">{{ selected.trackedMobile }}</div>
                            </div>
                            <div class="form-group basic" v-if="selected.trackedNote">
                                <label class="label">നോട്ട്</label>
                                <div class="loc-view-value">{{ selected.trackedNote }}</div>
                            </div>
                            <div class="form-group basic" v-if="selected.trackedAt">
                                <label class="label">അപ്ഡേറ്റ് ചെയ്തത്</label>
                                <div class="loc-view-value">{{ formatDate(selected.trackedAt) }}</div>
                            </div>
                            <p class="mal-text text-muted" style="font-size:12px;margin-top:10px;">
                                ഈ അംഗത്തിന്റെ സ്വന്തം ജില്ല/മണ്ഡലം/ശാഖ അഡ്മിന് മാത്രമേ ഇത് മാറ്റാൻ കഴിയൂ.
                            </p>
                        </div>
                        <div class="action-sheet-content" v-else>
                            <div class="loc-mode-row mb-3">
                                <button type="button" class="loc-mode-btn" :class="{ active: locationMode === 'kerala' }" @click="locationMode = 'kerala'">കേരളത്തിൽ</button>
                                <button type="button" class="loc-mode-btn" :class="{ active: locationMode === 'state' }" @click="setLocationMode('state')">കേരളത്തിന് പുറത്ത്</button>
                                <button type="button" class="loc-mode-btn" :class="{ active: locationMode === 'country' }" @click="setLocationMode('country')">ഇന്ത്യക്ക് പുറത്ത്</button>
                            </div>
                            <form @submit.prevent="submitLocation">
                                <template v-if="locationMode === 'kerala'">
                                    <div class="form-group basic">
                                        <label class="label" for="locDistrictSelect">{{ $t('select_district') }}</label>
                                        <select v-model="selectedDistrict" class="form-control" id="locDistrictSelect" @change="onDistrictChange">
                                            <option value="">-- {{ $t('select_district') }} --</option>
                                            <option v-for="district in district_list" :key="district.id" :value="district.id">{{ district.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group basic">
                                        <label class="label" for="locZoneSelect">{{ $t('select_zone') }}</label>
                                        <select v-model="selectedZone" class="form-control" id="locZoneSelect" @change="onZoneChange">
                                            <option value="">-- {{ $t('select_zone') }} --</option>
                                            <option v-for="zone in zone_list" :key="zone.id" :value="zone.id">{{ zone.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group basic text-center" v-if="selectedZone && unitsLoading">
                                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                                    </div>
                                    <div class="form-group basic" v-else-if="selectedZone && unit_list.length">
                                        <label class="label" for="locUnitSelect">{{ $t('select_unit') }}</label>
                                        <select v-model="selectedUnit" class="form-control" id="locUnitSelect">
                                            <option value="">-- {{ $t('select_unit') }} --</option>
                                            <option v-for="unit in unit_list" :key="unit.id" :value="unit.id">{{ unit.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group basic mal-text" v-else-if="selectedZone" style="font-size:12px;color:#888;">
                                        ഈ സോണിന് കീഴിൽ യൂണിറ്റുകൾ ഇല്ല — സോൺ തലത്തിൽ ട്രാക്ക് ചെയ്യും.
                                    </div>
                                </template>
                                <div class="form-group basic" v-else-if="locationMode === 'state'">
                                    <label class="label">സംസ്ഥാനം</label>
                                    <select v-model="selectedState" class="form-control">
                                        <option value="">-- സംസ്ഥാനം തിരഞ്ഞെടുക്കുക --</option>
                                        <option v-for="s in state_list" :key="s.id" :value="s.item_value">{{ s.name }}</option>
                                    </select>
                                </div>
                                <template v-else-if="locationMode === 'country'">
                                    <div class="form-group basic">
                                        <label class="label">രാജ്യം</label>
                                        <select v-model="selectedCountry" class="form-control">
                                            <option value="">-- രാജ്യം തിരഞ്ഞെടുക്കുക --</option>
                                            <option v-for="c in country_list" :key="c.id" :value="c.item_value">{{ c.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group basic">
                                        <label class="label">മൊബൈൽ നമ്പർ <span class="text-muted" style="font-weight:400;">(Not Required)</span></label>
                                        <input v-model="locationMobile" type="tel" class="form-control" placeholder="Mobile Number">
                                    </div>
                                </template>
                                <div class="form-group basic">
                                    <label class="label">നോട്ട് <span class="text-muted" style="font-weight:400;">(Not Required)</span></label>
                                    <textarea v-model="locationNote" class="form-control" rows="2" placeholder="Note"></textarea>
                                </div>
                                <div class="form-group basic mb-0 loc-action-row">
                                    <button type="submit" class="btn btn-primary btn-lg" :disabled="!canSubmitLocation || locationSaving">
                                        <span v-show="locationSaving" class="spinner-border spinner-border-sm"></span>
                                        {{ $t('submit') }}
                                    </button>
                                    <button type="button" class="btn btn-outline-secondary btn-lg" :disabled="locationSaving" @click="clearLocation">
                                        ക്ലിയർ ചെയ്യുക
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    </div>
</template>

<script>
import UserService from "../services/user.service";
import $ from 'jquery';
import AlertModel from "./layouts/AlertModel.vue";

export default {
    name: 'MembersTracking',
    components: {
        AlertModel,
    },
    data() {
        return {
            wing: '',
            search: '',
            results: [],
            loadingList: false,
            searchTimer: null,
            selected: null,
            pagination: { current_page: 1, last_page: 1, total: 0 },

            member_id: '',

            // Location-setting modal
            locationMode: 'kerala',
            district_list: [],
            zone_list: [],
            unit_list: [],
            selectedDistrict: '',
            selectedZone: '',
            selectedUnit: '',
            unitsLoading: false,
            state_list: [],
            country_list: [],
            selectedState: '',
            selectedCountry: '',
            locationMobile: '',
            locationNote: '',
            locationSaving: false,

            // List-page filter (by current tracked location)
            filterMode: '',
            filterDistrictList: [],
            filterZoneList: [],
            filterUnitList: [],
            filterDistrictId: '',
            filterZoneId: '',
            filterUnitId: '',
            filterState: '',
            filterCountry: '',

            alert_type: '',
            alert_message: '',
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        canSubmitLocation() {
            if (this.locationMode === 'kerala') {
                if (this.selectedUnit) return true;
                // A zone with no Units at all — fall back to zone-level tracking.
                return !!(this.selectedZone && !this.unitsLoading && !this.unit_list.length);
            }
            if (this.locationMode === 'state') return !!this.selectedState;
            if (this.locationMode === 'country') return !!this.selectedCountry;
            return false;
        },
        showDistrictFilter() {
            return this.currentUser && this.currentUser.user_level === 1;
        },
        showZoneFilter() {
            if (!this.currentUser) return false;
            if (this.currentUser.user_level === 2) return true;
            return this.currentUser.user_level === 1 && !!this.filterDistrictId;
        },
        showUnitFilter() {
            if (!this.currentUser) return false;
            if (this.currentUser.user_level === 3) return true;
            if (this.currentUser.user_level === 2) return !!this.filterZoneId;
            return this.currentUser.user_level === 1 && !!this.filterZoneId;
        },
    },
    mounted() {
        this.initFilters();
        this.loadList(1);
    },
    methods: {
        setWing(wing) {
            this.wing = wing;
            this.loadList(1);
        },
        onSearch() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.loadList(1);
            }, 350);
        },
        loadList(page = 1) {
            this.loadingList = true;
            const payload = { query_text: this.search.trim(), wing: this.wing };
            if (this.filterUnitId) {
                payload.filter_unit_id = this.filterUnitId;
            } else if (this.filterZoneId) {
                payload.filter_zone_id = this.filterZoneId;
            } else if (this.filterDistrictId) {
                payload.filter_district_id = this.filterDistrictId;
            } else if (this.filterMode === 'outside_kerala' && this.filterState) {
                payload.filter_state = this.filterState;
            } else if (this.filterMode === 'outside_kerala') {
                payload.filter_outside_kerala = 1;
            } else if (this.filterMode === 'outside_india' && this.filterCountry) {
                payload.filter_country = this.filterCountry;
            } else if (this.filterMode === 'outside_india') {
                payload.filter_outside_india = 1;
            }
            UserService.authPostRequest(`search-member-tracking?page=${page}`, payload).then((response) => {
                this.loadingList = false;
                if (response.data.status === 'success') {
                    this.results = response.data.data.list || [];
                    this.pagination = {
                        current_page: response.data.data.current_page || 1,
                        last_page: response.data.data.last_page || 1,
                        total: response.data.data.total || 0,
                    };
                }
            }).catch(() => { this.loadingList = false; });
        },
        // List-page filter (by current tracked location)
        initFilters() {
            if (!this.currentUser) return;
            const ul = this.currentUser.user_level;
            if (ul === 1) {
                UserService.authPostRequest('get-district-by-id', {}).then((response) => {
                    this.filterDistrictList = response.data.status === 'success' ? response.data.data.list : [];
                });
            } else if (ul === 2) {
                UserService.authPostRequest('get-zone-by-id', { district_id: this.currentUser.district_id }).then((response) => {
                    this.filterZoneList = response.data.status === 'success' ? response.data.data.list : [];
                });
            } else if (ul === 3) {
                UserService.authPostRequest('get-unit-by-id', { zone_id: this.currentUser.zone_id }).then((response) => {
                    this.filterUnitList = response.data.status === 'success' ? response.data.data.list : [];
                });
            }
        },
        onFilterDistrictChange() {
            this.filterZoneId = '';
            this.filterZoneList = [];
            this.filterUnitId = '';
            this.filterUnitList = [];
            this.filterMode = '';
            if (this.filterDistrictId) {
                UserService.authPostRequest('get-zone-by-id', { district_id: this.filterDistrictId }).then((response) => {
                    this.filterZoneList = response.data.status === 'success' ? response.data.data.list : [];
                });
            }
            this.loadList(1);
        },
        onFilterZoneChange() {
            this.filterUnitId = '';
            this.filterUnitList = [];
            this.filterMode = '';
            if (this.filterZoneId) {
                UserService.authPostRequest('get-unit-by-id', { zone_id: this.filterZoneId }).then((response) => {
                    this.filterUnitList = response.data.status === 'success' ? response.data.data.list : [];
                });
            }
            this.loadList(1);
        },
        onFilterUnitChange() {
            this.filterMode = '';
            this.loadList(1);
        },
        toggleOutsideKerala() {
            this.filterMode = this.filterMode === 'outside_kerala' ? '' : 'outside_kerala';
            this.filterDistrictId = '';
            this.filterZoneId = '';
            this.filterUnitId = '';
            this.filterCountry = '';
            this.filterState = '';
            if (this.filterMode === 'outside_kerala' && !this.state_list.length) {
                UserService.getCombobox({ code: 'STATES_INDIA' }).then((response) => {
                    this.state_list = response.data.data.list.options || [];
                });
            }
            this.loadList(1);
        },
        toggleOutsideIndia() {
            this.filterMode = this.filterMode === 'outside_india' ? '' : 'outside_india';
            this.filterDistrictId = '';
            this.filterZoneId = '';
            this.filterUnitId = '';
            this.filterState = '';
            this.filterCountry = '';
            if (this.filterMode === 'outside_india' && !this.country_list.length) {
                UserService.getCombobox({ code: 'COUNTRY' }).then((response) => {
                    this.country_list = response.data.data.list.options || [];
                });
            }
            this.loadList(1);
        },
        onFilterStateChange() {
            this.loadList(1);
        },
        onFilterCountryChange() {
            this.loadList(1);
        },
        // A search can span other admins' scopes entirely (e.g. "Outside India" is global, per
        // searchMemberTracking()), but editing a member's tracked location stays with their own
        // district/zone/unit admin. `canEditLocation` is computed server-side in
        // listMembersTracking() using the exact same rule updateCurrentLocation() enforces on
        // save — trust that flag rather than re-deriving it here, so this can never show an
        // edit affordance a save would then reject.
        canEditMemberLocation(m) {
            return !!m.canEditLocation;
        },
        rowStyle(m) {
            // A member from another district/zone/unit — view-only here, tinted to stand apart
            // from the admin's own members (who keep the normal/tracked-here styling below).
            if (!this.canEditMemberLocation(m)) {
                return { 'background-color': '#fdf3e7' };
            }
            if (m.is_tracked_here) {
                return { 'background-color': '#eaf3ff' };
            }
            return {};
        },
        homeLabel(m) {
            return (m.unit && m.unit.name) || (m.zone && m.zone.name) || (m.district && m.district.name) || '';
        },
        isTracked(m) {
            return !!(m.trackedUnitId || m.trackedZoneId || m.trackedState || m.trackedCountry);
        },
        currentLocationLabel(m) {
            return (m.trackedUnit && m.trackedUnit.name) || (m.trackedZone && m.trackedZone.name) || m.trackedState || m.trackedCountry || this.homeLabel(m);
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN');
        },
        // Current location (trackedUnitId/trackedZoneId/trackedState/trackedCountry) modal
        setLocationMode(mode) {
            this.locationMode = mode;
            if (mode === 'state' && !this.state_list.length) {
                UserService.getCombobox({ code: 'STATES_INDIA' }).then((response) => {
                    this.state_list = response.data.data.list.options || [];
                });
            }
            if (mode === 'country' && !this.country_list.length) {
                UserService.getCombobox({ code: 'COUNTRY' }).then((response) => {
                    this.country_list = response.data.data.list.options || [];
                });
            }
        },
        getZoneList(district_id) {
            this.zone_list = [];
            this.unit_list = [];
            this.selectedZone = '';
            this.selectedUnit = '';
            if (!district_id) return Promise.resolve();
            return UserService.authPostRequest('get-zone-by-id', { district_id }).then((response) => {
                this.zone_list = response.data.status === 'success' ? response.data.data.list : [];
            }).catch(() => { this.zone_list = []; });
        },
        getUnitList(zone_id) {
            this.unit_list = [];
            this.selectedUnit = '';
            if (!zone_id) return Promise.resolve();
            this.unitsLoading = true;
            return UserService.authPostRequest('get-unit-by-id', { zone_id }).then((response) => {
                this.unitsLoading = false;
                this.unit_list = response.data.status === 'success' ? response.data.data.list : [];
            }).catch(() => { this.unitsLoading = false; this.unit_list = []; });
        },
        onDistrictChange() {
            this.getZoneList(this.selectedDistrict);
        },
        onZoneChange() {
            this.getUnitList(this.selectedZone);
        },
        async openLocationModal(m) {
            this.selected = m;
            this.member_id = m.id;
            this.district_list = [];
            this.zone_list = [];
            this.unit_list = [];
            this.selectedDistrict = '';
            this.selectedZone = '';
            this.selectedUnit = '';
            this.selectedState = m.trackedState || '';
            this.selectedCountry = m.trackedCountry || '';
            this.locationMobile = m.trackedMobile || '';
            this.locationNote = m.trackedNote || '';
            this.locationMode = m.trackedState ? 'state' : (m.trackedCountry ? 'country' : 'kerala');
            if (this.locationMode !== 'kerala') this.setLocationMode(this.locationMode);

            $('#locationModal').modal('show');

            // View-only for a member outside this admin's own scope — skip the edit-form
            // district/zone/unit prefetch entirely, nothing here can be submitted anyway.
            if (!m.canEditLocation) return;

            try {
                const districtResponse = await UserService.authPostRequest('get-district-by-id', {});
                if (districtResponse.data.status === 'success') {
                    this.district_list = districtResponse.data.data.list;
                    this.selectedDistrict = (m.trackedUnit && m.trackedUnit.district_id) || (m.trackedZone && m.trackedZone.district_id) || '';
                }
                if (this.selectedDistrict) {
                    const zoneResponse = await UserService.authPostRequest('get-zone-by-id', { district_id: this.selectedDistrict });
                    if (zoneResponse.data.status === 'success') {
                        this.zone_list = zoneResponse.data.data.list;
                        this.selectedZone = (m.trackedUnit && m.trackedUnit.zone_id) || m.trackedZoneId || '';
                    }
                }
                if (this.selectedZone) {
                    await this.getUnitList(this.selectedZone);
                    this.selectedUnit = m.trackedUnitId || '';
                }
            } catch (error) {
                this.alert_type = 'Error';
                this.alert_message = error.message || 'An error occurred while fetching data.';
                this.$refs.alert_model.openModel();
            }
        },
        submitLocation() {
            const extra = { note: this.locationNote };
            if (this.locationMode === 'kerala') {
                if (this.selectedUnit) {
                    this.saveLocation({ unit_id: this.selectedUnit, ...extra });
                } else if (this.selectedZone && !this.unit_list.length) {
                    this.saveLocation({ zone_id: this.selectedZone, ...extra });
                }
            } else if (this.locationMode === 'state' && this.selectedState) {
                this.saveLocation({ state: this.selectedState, ...extra });
            } else if (this.locationMode === 'country' && this.selectedCountry) {
                this.saveLocation({ country: this.selectedCountry, mobile: this.locationMobile, ...extra });
            }
        },
        clearLocation() {
            this.saveLocation({});
        },
        saveLocation(payload) {
            this.locationSaving = true;
            UserService.authPostRequest('update-member-tracked-location', { member_id: this.member_id, ...payload }).then(
                (response) => {
                    this.locationSaving = false;
                    this.alert_type = response.data.status === 'success' ? 'Success' : (response.data.status === 'warning' ? 'Warning' : 'Error');
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    if (response.data.status === 'success') {
                        $('#locationModal').modal('hide');
                        this.loadList(this.pagination.current_page);
                    }
                },
                (error) => {
                    this.locationSaving = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>

<style scoped>
/* .listview.inset adds its own 16px side margins on top of the parent .section's
   16px padding, making this list narrower than the filter/search cards above it
   (which only get the section's padding). Zero it out so the widths match. */
.tracking-listview.inset {
    margin-left: 0;
    margin-right: 0;
}

.tab-container-1 {
    display: flex;
    justify-content: center;
    margin: 1.5rem 0 1rem 0;
}

.pill-tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    max-width: 600px;
    margin: 0 auto;
}

.pill-tab {
    flex: 1 1 140px;
    min-width: 120px;
    max-width: 200px;
    padding: 0.6rem 1rem;
    border: none;
    border-radius: 999px;
    background: #f5f7fa;
    color: #1a418c;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.18s, color 0.18s, box-shadow 0.18s;
    outline: none;
    box-shadow: 0 1px 3px rgba(26, 65, 140, 0.04);
    margin: 0;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

.pill-tab.active,
.pill-tab:focus {
    background: #1a418c;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(26, 65, 140, 0.10);
}

@media (max-width: 800px) {
    .pill-tabs {
        max-width: 100%;
        gap: 0.7rem;
    }

    .pill-tab {
        flex: 1 1 110px;
        font-size: 0.98rem;
        padding: 0.5rem 0.7rem;
    }
}

@media (max-width: 500px) {
    .pill-tabs {
        gap: 0.5rem;
    }

    .pill-tab {
        flex: 1 1 90px;
        font-size: 0.95rem;
        padding: 0.45rem 0.5rem;
    }
}

@media (max-width: 380px) {
    .pill-tab {
        font-size: 0.66rem;
        padding: 0.4rem 0.2rem;
    }
}

.tracking-toggle-row {
    display: flex;
    gap: 0.5rem;
}

.tracking-toggle-btn {
    flex: 1;
    padding: 0.55rem 0.4rem;
    border: none;
    border-radius: 10px;
    background: #f5f7fa;
    color: #92640a;
    font-size: 0.82rem;
    font-weight: 700;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
}

.tracking-toggle-btn.active {
    background: #f0a500;
    color: #fff;
}

.tracking-toggle-btn.danger {
    color: #c0392b;
}

.tracking-toggle-btn.danger.active {
    background: #e74c3c;
    color: #fff;
}

.loc-mode-row {
    display: flex;
    gap: 0.3rem;
}

.loc-mode-btn {
    flex: 1;
    min-width: 0;
    padding: 0.5rem 0.2rem;
    border: 1px solid #1a418c;
    border-radius: 8px;
    background: #fff;
    color: #1a418c;
    font-size: 0.72rem;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

@media (max-width: 360px) {
    .loc-mode-btn {
        font-size: 0.64rem;
        padding: 0.45rem 0.15rem;
        letter-spacing: -0.02em;
    }
}

.loc-mode-btn.active {
    background: #1a418c;
    color: #fff;
}

.loc-action-row {
    display: flex;
    gap: 0.5rem;
}

.loc-action-row .btn {
    flex: 1;
    margin: 0;
}

.loc-view-value {
    padding: 0.5rem 0.7rem;
    background: #f5f7fa;
    border-radius: 8px;
    color: #27173E;
    font-weight: 600;
    font-size: 0.95rem;
}
</style>
